// react
import React from 'react';

// material ui
import { Card, CardContent, CardHeader, Stack } from '@mui/material';

interface DetailHeaderCardProps {
  title: string;
  subheader?: string | null;
  avatar: React.ReactElement;
  /** Optional action element rendered in the top-right of the card header */
  action?: React.ReactNode;
  /** Gap between field items in the content stack (MUI spacing units) */
  gap?: number;
  children: React.ReactNode;
}

/**
 * Shared card shell used by UnitDetailHeader, SensorDetailHeader and
 * GatewayDetailHeader. Renders a Card with a bordered header and a
 * horizontally-wrapped content area.
 */
const DetailHeaderCard = ({
  title,
  subheader,
  avatar,
  action,
  gap,
  children,
}: DetailHeaderCardProps) => {
  return (
    <Card variant="outlined">
      <CardHeader
        title={title}
        subheader={subheader || undefined}
        avatar={avatar}
        action={action}
        sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
        slotProps={{
          title: { variant: 'h6' }
        }}
      />
      <CardContent>
        <Stack
          direction="row"
          flexWrap="wrap"
          justifyContent="space-between"
          {...(gap !== undefined ? { gap } : {})}
        >
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default DetailHeaderCard;
